// ─── Points à la carte : appels FIRESTORE (Core) ───────────────────
// Contrairement aux jetons (Cloud Functions, quota à faire respecter
// serveur), une DEMANDE à la carte n'accorde rien par elle-même — comme
// `planDemande`, c'est un dépôt que seule l'administration transforme en
// octroi réel (`fonctionnalitesAchetees`/`quotasAchetes`, verrouillés côté
// règles). Écriture directe suffit donc, pas de callable.
import { doc, onSnapshot, setDoc, deleteField } from 'firebase/firestore';
import { db } from '../firebase';
import { BAREME_DEFAUT } from './pointsALaCarte';

export function ecouterBareme(callback, onErreur) {
  return onSnapshot(doc(db, 'config', 'pointsALaCarte'),
    (snap) => callback(snap.exists() && Array.isArray(snap.data().bareme) ? snap.data().bareme : BAREME_DEFAUT),
    (e) => { callback(BAREME_DEFAUT); onErreur?.(e); });
}

// `selection` : { fonctions: [cle], quotas: { [cle]: n } }.
export function demanderAchats(uid, selection) {
  if (!uid) return Promise.resolve();
  return setDoc(doc(db, 'users', uid), {
    achatsDemande: selection, achatsDemandeLe: new Date().toISOString(),
  }, { merge: true });
}
export function annulerDemandeAchats(uid) {
  if (!uid) return Promise.resolve();
  return setDoc(doc(db, 'users', uid), {
    achatsDemande: deleteField(), achatsDemandeLe: deleteField(),
  }, { merge: true });
}
